import { DELIVERY_SECTION_ELEMENT } from "@swiggy-private/checkout-core";

export enum APP_STORAGE_KEYS_FOR_DELIVERY_SPEED {
    // This is used to track half card or crouton count per seeion basis
    // User cannot be both XP's at same time. So we can use one sid key to track them based on xp
    SID = "ds_sid",
    HALF_CARD_COUNT = "ds_half_card_count",
    CROUTON_COUNT = "ds_crouton_count",
    NEW_TAG_COUNT = "ds_new_tag_count",
    // This is used to track new tag count on session basis.
    // We cannot use same sid as there are cases where we show new tag but not half card or crouton
    NEW_TAG_SID = "ds_new_tag_sid",
}

// Limit value for new tag for first time user experience for delivery speed
export const FTUE_LIMIT = 3;

// Limit value for Popup
export const DELIVERY_SPEED_POPUP_COUNT_LIMIT = 2;
// Limit value for crouton for sessions after defaulting delivery speed
export const CROUTON_LIMIT = 2;

export const NUDGE_CART_CATEGORY_TYPE = {
    POCKET_HERO: "POCKET_HERO",
};

export const DELIVERY_TAB_LABELS = {
    [DELIVERY_SECTION_ELEMENT.DELIVERY_TYPE]: "Delivery Type",
    [DELIVERY_SECTION_ELEMENT.TIP]: "Tip",
    [DELIVERY_SECTION_ELEMENT.INSTRUCTIONS]: "Instructions",
    [DELIVERY_SECTION_ELEMENT.SELF_DELIVERY]: "Instructions",
};

export const CLICK_HERE_TO_SELECT = "Click here to select {0} tab";
export const SELECTED_DELIVERY_TAB = "{0} tab is selected";

export const VALID_DELIVERY_RENDERING_ITEMS = [
    DELIVERY_SECTION_ELEMENT.DELIVERY_TYPE,
    DELIVERY_SECTION_ELEMENT.TIP,
    DELIVERY_SECTION_ELEMENT.INSTRUCTIONS,
    DELIVERY_SECTION_ELEMENT.SELF_DELIVERY,
];

export const DELIVERY_TYPE_NOT_AVAILABLE = "Not available at the moment";
export const DELIVERY_TYPE_ADD_ADDRESS = "Add address to check delivery time";

export const DELIVERY_SUBHEADING_BOLT_STANDARD = "Lightning fast delivery";

export const SLA_COMMS_LOGO_ID = "portal/m/Running1.png";

export const SINGLE_MODE_SERVICABLE_SLA_TEXT = "Other delivery types are currently unavailable";
